import "@stimulus/polyfills";
import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";

export default () => {
    const application = Application.start();

    const context = require.context("./controllers", true, /\.js$/);

    application.load(definitionsFromContext(context));
};



// WEBPACK FOOTER //
// ./public/assets/scripts/bootstrap.js